// @flow
import React, { PureComponent } from 'react';
import { Link } from 'react-router-dom';

export type Props = {
  title: string,
  jobtype: string,
  type_contrat: string,
  city: string,
  link: string,
  club: string,
  embleme: string,
};

class CardJob extends PureComponent<Props> {
  props: Props;

  static defaultProps = {
    title: '',
    jobtype: '',
    type_contrat: '',
    city: '',
    link: '',
    club: '',
    embleme: '',
  };

  render() {
    const { link, title, jobtype, type_contrat, city, club, embleme } = this.props;

    return (
      <Link to={link} title={`Découvrir l'offre ${title}`} className="box box--white card card--job card--job-alt">
        <div className="card__body">
          { embleme !== '' &&
          <img src={embleme} width="32" height="32" alt={`Logo ${club}`} className="mb-1" /> }
          { club !== '' &&
          <p className="ft-h6 ft-black-secondary ft-truncat ft-up mb-0">{ club }</p> }
          <h3 className="card__title ft-h3">{title}</h3>
          <p className="card__meta ft-h6 ft-up">
            { jobtype !== '' &&
              <span><i className="icon icon-jersey is-inline"></i> { jobtype }<br /></span> }
            { type_contrat !== '' &&
              <span><i className="icon icon-case is-inline" /> { type_contrat } <br /></span> }
            { city !== '' &&
              <span><i className="icon icon-place is-inline" /> { city }</span> }
          </p>
        </div>
      </Link>
    );
  }
}
export default CardJob;
